module.exports = __webpack_public_path__ + "img/x2.f3aa0a5e.jpg";